var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"re-table"},_vm._l((_vm.data),function(row,index){return _c('div',{key:row.name},[_c('re-table-row',{attrs:{"row":row,"columns":_vm.columns,"index":index}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }